import { WEB_PREFIX } from 'constants/common';

export const TEST_ID_TEXT_INPUT_HINT = `${WEB_PREFIX}text-input_hint`;
export const TEST_ID_TEXT_INPUT_ERROR_HINT = `${WEB_PREFIX}text-input_error-hint`;

export const TEST_NAVIGATION_CHEVRON_LEFT = `${WEB_PREFIX}navigation_chevron-left-button`;
export const TEST_NAVIGATION_DOT_MENU_BTN = `${WEB_PREFIX}navigation_meatball-button`;

export const TEST_ID_TOAST_VIEW = `${WEB_PREFIX}toast-view`;
